// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  registration: {
    name: 'registrationPage',
    componentName: 'RegistrationPage',
    chunk: () =>
      import(
        /* webpackChunkName: "RegistrationPage" */
        './pages/RegistrationPage'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/RegistrationPage.tsx'),
          ).RegistrationPage
        : currentRouteName === 'registrationPage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.RegistrationPage,
            })),
          );
    },
    path: '/:context?/myaccount/proXtraPricing/registration',
    channel: null,
  },
  pricingBenefits: {
    name: 'pricingBenefitsPage',
    componentName: 'PricingPageWrapper',
    chunk: () =>
      import(
        /* webpackChunkName: "PricingPageWrapper" */
        './pages/PricingPageWrapper'
      ),
    get component() {
      return ssr
        ? __webpack_require__(
            require.resolveWeak('@cwd/src/pages/PricingPageWrapper.tsx'),
          ).PricingPageWrapper
        : currentRouteName === 'pricingBenefitsPage'
        ? currentRouteComponent
        : generateAsyncRoute(() =>
            this.chunk().then((pageModule) => ({
              default: pageModule.PricingPageWrapper,
            })),
          );
    },
    path: '/:context?/myaccount/proXtraPricing',
    channel: null,
  },
});
